import { Utensils, Bike, ShoppingBag } from 'lucide-react';

/**
 * Sprint 104 — Tres formas de vender, no dos.
 *
 * Faltaba la más vieja del oficio: **el cliente llega, pide para llevar y espera**. Se venía
 * capturando como "comer aquí sin mesa" —funcionaba de casualidad— y por eso el sistema le pedía
 * una mesa que no existe y no lo distinguía de nadie después.
 *
 * `para_llevar` no es un tipo nuevo en la base: es `comer_aqui` sin mesa con la marca
 * `paraRecoger`. Lo que cambia aquí es el **camino**, que es lo que vive el operador.
 */
export type TipoVentaElegido = 'comer_aqui' | 'delivery' | 'para_llevar';

interface Props {
  onSelect: (tipo: TipoVentaElegido) => void;
}

export function TipoVentaSelector({ onSelect }: Props) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <h1 className="mb-2 text-3xl font-bold">Nuevo pedido</h1>
        <p className="mb-8 text-slate-500">¿Cómo se va a consumir el pedido?</p>

        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={() => onSelect('comer_aqui')}
            data-uso="venta:comer-aqui"
            className="card flex w-56 flex-col items-center gap-3 hover:border-primary hover:shadow-lg transition cursor-pointer"
          >
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 text-primary">
              <Utensils className="h-10 w-10" />
            </div>
            <div className="text-lg font-semibold">Comer aquí</div>
            <div className="text-xs text-slate-500">El cliente está en mesa</div>
          </button>

          {/*
            Sprint 104 — Venta de mostrador.

            Va en medio a propósito: es más frecuente que el domicilio en la mayoría de los
            negocios de este tamaño, y hasta hoy no tenía dónde caer.
          */}
          <button
            onClick={() => onSelect('para_llevar')}
            data-uso="venta:para-llevar"
            className="card flex w-56 flex-col items-center gap-3 hover:border-primary hover:shadow-lg transition cursor-pointer"
          >
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
              <ShoppingBag className="h-10 w-10" />
            </div>
            <div className="text-lg font-semibold">Pasa a recogerlo</div>
            <div className="text-xs text-slate-500">Se lo lleva, sin mesa y sin envío</div>
          </button>

          <button
            onClick={() => onSelect('delivery')}
            data-uso="venta:domicilio"
            className="card flex w-56 flex-col items-center gap-3 hover:border-primary hover:shadow-lg transition cursor-pointer"
          >
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-orange-100 text-orange-600">
              <Bike className="h-10 w-10" />
            </div>
            <div className="text-lg font-semibold">A domicilio</div>
            <div className="text-xs text-slate-500">Se envía a la casa del cliente</div>
          </button>
        </div>
      </div>
    </div>
  );
}
